import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { colors, fonts } from '../brand';
import Disclaimer from '../components/Disclaimer';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'This link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <p style={styles.tagline}>Invalid reset link. <Link to="/forgot-password" style={styles.a}>Request a new one.</Link></p>
      </div>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        <img src="/logo.svg" alt="Elephants Answering" style={styles.logoIcon} />
        <div>
          <div style={styles.logoText}>Elephants Answering, PBC</div>
          <div style={styles.logoSub}>Divorce Support & Refuge</div>
        </div>
      </div>

      <div style={styles.card}>
        {done ? (
          <>
            <h2 style={styles.title}>Password updated</h2>
            <p style={styles.tagline}>Your password has been reset. You can now sign in.</p>
            <button style={styles.button} onClick={() => navigate('/login')}>Sign In</button>
          </>
        ) : (
          <>
            <h2 style={styles.title}>Set a new password</h2>
            <p style={styles.tagline}>Choose a new password for your account.</p>
            {error && <div style={styles.error}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <input
                style={styles.input}
                type="password"
                placeholder="New password (8+ characters)"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <input
                style={styles.input}
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
              <button style={styles.button} type="submit" disabled={loading}>
                {loading ? 'Updating...' : 'Update Password'}
              </button>
            </form>
          </>
        )}
      </div>
      <Disclaimer />
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: colors.cream, padding: '40px 20px' },
  logoArea: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px', cursor: 'pointer' },
  logoIcon: { height: '140px', width: 'auto' },
  logoText: { fontFamily: fonts.heading, color: colors.navy, fontSize: '17px', fontWeight: '600', letterSpacing: '0.5px' },
  logoSub: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '11px', letterSpacing: '0.3px', marginTop: '3px' },
  card: { backgroundColor: colors.white, border: `1px solid ${colors.peach}`, padding: '48px 40px', maxWidth: '420px', width: '100%' },
  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '24px', marginBottom: '8px', fontWeight: '600', letterSpacing: '0.3px' },
  tagline: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '13px', marginBottom: '32px', fontStyle: 'italic', lineHeight: '1.7' },
  error: { backgroundColor: '#fde8e8', color: '#c0392b', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', fontFamily: fonts.body, border: '1px solid #f5c6c6' },
  input: { display: 'block', width: '100%', padding: '12px 16px', marginBottom: '16px', border: `1px solid ${colors.peach}`, fontSize: '14px', fontFamily: fonts.body, boxSizing: 'border-box', outline: 'none', color: colors.navy, backgroundColor: colors.white, borderRadius: 0 },
  button: { display: 'block', width: '100%', padding: '14px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '14px', cursor: 'pointer', fontWeight: '600', fontFamily: fonts.body, letterSpacing: '0.5px', borderRadius: 0 },
  a: { color: colors.rose, textDecoration: 'none', fontWeight: '600' },
};
